import styled from "@emotion/styled";

const StyledAnimatedSvg = styled.div<{ hover?: boolean }>`
  p {
    top: 0;
    margin-top: -1px;
    left: -30px;
    position: absolute;
    width: 20px;
    svg {
      height: 100% !important;
      width: 100% !important;
    }
  }
  > svg {
    position: absolute;
    top: 0;
    left: -30px;
    transition: all 0.2s ease-in-out;
  }
  svg:first-of-type {
    opacity: ${(props) => (props.hover ? 0 : 1)};
  }
  svg:nth-of-type(2) {
    opacity: ${(props) => (props.hover ? 1 : 0)};
  }
`;

export { StyledAnimatedSvg };
